/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// Inputs sin setCheck a propósito: el legacy pasaba el tipo como 2º argumento de
// appendValueInput, que Blockly ignora, así que nunca tuvieron check.

Blockly.Blocks.serial_print = {
  // Solo habilita "Ayuda"; el panel se arma con el tipo del bloque. Ver features/utils/blockHelp.js.
  helpUrl: 'http://www.arduino.cc/en/Serial/Print',
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('CONTENT')
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_PRINT);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_ADVANCED_SERIAL_PRINT_TOOLTIP);
  },
};

Blockly.Blocks.serial_println = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('CONTENT')
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_PRINTLN);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_ADVANCED_SERIAL_PRINTLN_TOOLTIP);
  },
};

Blockly.Blocks.serial_blue = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('CONTENT')
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_BLUE);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};

Blockly.Blocks.serial_read = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_READ);
    // Sin check a propósito: los inputs mezclan 'String' y el constructor String,
    // y cualquier token fijo rompe conexiones de un lado.
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ADVANCED_SERIAL_READ_TOOLTIP);
  },
};

Blockly.Blocks.serial_special = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_SPECIAL)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_ADVANCED_SERIAL_SPECIAL_TAB || 'TAB', '\\t'],
        [Blockly.Msg.LANG_ADVANCED_SERIAL_SPECIAL_CARRIAGE_RETURN || 'CARRIAGE RETURN', '\\r'],
        [Blockly.Msg.LANG_ADVANCED_SERIAL_SPECIAL_LINE_FEED || 'LINE FEED', '\\n'],
      ]), 'CHAR');
    // Sin check por el mismo motivo que serial_read (ver comentario alli).
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ADVANCED_SERIAL_SPECIAL_TOOLTIP);
  },
};

Blockly.Blocks.serial_available = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ADVANCED_SERIAL_AVAILABLE);
    this.appendStatementInput('DO')
      .appendField(Blockly.Msg.LANG_CONTROLS_REPEAT_INPUT_DO);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_ADVANCED_SERIAL_AVAILABLE_TOOLTIP);
  },
};

Blockly.Blocks.SALIDAS_buttons = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('PIN')
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/joystick/icon.png`, 32, 19))
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS_SPACE);
    this.appendStatementInput('BUTN1')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS_BUTTON_U)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/joystick/up.png`, 20, 20));
    this.appendStatementInput('BUTN2')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS_BUTTON_D)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/joystick/down.png`, 20, 20));
    this.appendStatementInput('BUTN4')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS_BUTTON_R)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/joystick/right.png`, 20, 20));
    this.appendStatementInput('BUTN3')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS_BUTTON_L)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/joystick/left.png`, 20, 20));
    this.appendStatementInput('BUTN7')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS_BUTTON_S)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/joystick/center.png`, 20, 20));
    this.appendStatementInput('BUTN5')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS_BUTTON_A);
    this.appendStatementInput('BUTN6')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_BUTTONS_BUTTON_B);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_BUTTONS_TOOLTIP);
  },
};

Blockly.Blocks.SALIDAS_scan_def = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SALIDAS_SCAN_DEF);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    // La clave no existe: queda sin tooltip a propósito, como en prod.
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_SCAN_DEF_TOOLTIP);
  },
};
